import type * as React from 'react';

import { divider } from './style';

interface DividerProps {
  vertical?: boolean;
  className?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Divider: React.FC<DividerProps> = ({ vertical, className }) => {
  return <hr className={`${divider(vertical)} ${className || ''}`} />;
};
